import authenticationAPI, { PayloadCredentialsRequest } from '@/api/authentication';

import session from '@/utils/session';

import Router from 'vue-router';

export async function userLogin(payloadCredentials: PayloadCredentialsRequest, router: Router) {
	await authenticationAPI.userLogin(payloadCredentials);
	router.push(`/`);
}

export async function agentLogin(payloadCredentials: PayloadCredentialsRequest, router: Router) {
	await authenticationAPI.agentLogin(payloadCredentials);
	router.push(`/admin`);
}

export async function logout() {
	await authenticationAPI.logout();
	window.location.href = '/';
}

export function requireAuth(role: string) {
	return (to: any, from: any, next: any) => {
		role = role.toUpperCase();
		if (!session.isLoggedIn() || !session.doesTokenHaveRole(role)) {
			if (role === 'AGENT') {
				return next({
					path: `/admin/login`
				});
			}
			else {
				return next({
					path: `/login`
				});
			}
		}

		return next();
	};
}
